import { createContext, useContext, ReactNode } from 'react';
import { getTenant, TenantResult } from '../hooks/useTenant';

const TenantContext = createContext<TenantResult>({ slug: null, isTenant: false });

export function TenantProvider({ children }: { children: ReactNode }) {
  const tenant = getTenant();
  return (
    <TenantContext.Provider value={tenant}>
      {children}
    </TenantContext.Provider>
  );
}

export function useTenantContext(): TenantResult {
  return useContext(TenantContext);
}
